/**
 * Configuracao compartilhada do hls.js.
 *
 * POR QUE ISTO EXISTE
 * A pagina roda em belladasemana.com.br e o video vem de
 * hls.belladasemana.com.br — origens diferentes. O cookie de acesso ao video
 * (vtok/vexp/vuid) so acompanha a requisicao se o cliente pedir credenciais
 * explicitamente, e o hls.js NAO faz isso por padrao.
 *
 * Sem isto, o servidor de video nao ve o cookie. Medido em producao
 * (14/08/2026), com o campo uid no log do nginx: das requisicoes a /hls/,
 * ZERO chegavam com cookie, enquanto as chamadas de API (feitas pelo axios,
 * que ja tem withCredentials) chegavam todas.
 *
 * Consequencia se nao corrigir: no momento em que o nginx passar a exigir o
 * cookie, TODO video do site responde 403 — para todos os assinantes.
 *
 * Os dois ganchos sao definidos de proposito: o hls.js usa XhrLoader por
 * padrao, mas pode usar FetchLoader dependendo da configuracao/ambiente.
 * Cobrir so um deixaria um caminho sem credenciais.
 *
 * A tag <video> NAO precisa de tratamento: sem o atributo `crossorigin`, o
 * navegador ja envia cookies de mesmo site. Acrescentar
 * crossorigin="anonymous" quebraria justamente esse caso.
 */
export const hlsConfigComCredenciais = {
  xhrSetup: (xhr: XMLHttpRequest) => {
    xhr.withCredentials = true;
  },
  fetchSetup: (context: any, initParams: any) => {
    initParams.credentials = "include";
    return new Request(context.url, initParams);
  },
};
